import { App as AntApp, ConfigProvider, notification } from 'antd';
import { ScrollToTop } from 'components';
import { appNotificationConfig } from 'config/notification';
import { AuthContextProvider } from 'contexts/AuthContext';
import { HomeSessionProvider } from 'contexts/HomeSessionContext';
import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useLocation } from 'react-router-dom';
import Routes from 'routes';
import appTheme from 'theme/theme';
import * as Userpilot from 'tools/Userpilot';
import 'translations';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: 30 * 1000,
      retry: !import.meta.env.DEV,
    },
    mutations: {
      retry: false,
    },
  },
});

notification.config(appNotificationConfig);

export default function App() {
  const location = useLocation();

  React.useEffect(() => {
    Userpilot.reload();
  }, [location]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider {...appTheme}>
        <AntApp notification={appNotificationConfig}>
          <AuthContextProvider>
            <HomeSessionProvider>
              <ScrollToTop />
              <Routes />
            </HomeSessionProvider>
          </AuthContextProvider>
        </AntApp>
      </ConfigProvider>
    </QueryClientProvider>
  );
}
